import React from 'react'
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import MensCollImage from '../../assets/Men Collection/Mock-It-Male Caucasian Regular T-Shirt - Back.png'; // Path to your image
import WomensCollImage from '../../assets/Women Collection/Mock-It-Female Modeled Caucasian T-Shirt - Front.png'; // Path to your image



const GenderCollectionSection = () => {
  return (
    <section className="py-16 px-4 lg:px-0">
        <div className="container mx-auto flex flex-col md:flex-row gap-8">
          <Link to="/collections/all?gender=Women" className="text-gray-900 underline">
            {/* Women's Collection */}
            <div className="relative flex-1">
                <img src={WomensCollImage} alt="Womens Collection Image" className="w-full h-[700px] object-cover" />
                <div className="absolute bottom-8 left-8 bg-white bg-opacity-90 p-4">
                    <h2 className="text-2xl font-bold text-gray-900 mb-3">VESHH-EON Women</h2>
                    
                    Shop Now 
                    
                </div>
            </div>

            </Link>

            {/* Men's Collection */}
            
            <div className="relative flex-1">
              <Link to="/collections/all?gender=Men " className="text-gray-900 underline">
                <img src={MensCollImage} alt="Mens Collection Image" className="w-full h-[700px] object-cover" />
                <div className="absolute bottom-8 left-8 bg-white bg-opacity-90 p-4">
                    <h2 className="text-2xl font-bold text-gray-900 mb-3">VESHH-EON Men</h2>
                    
                    Shop Now 
                    
                </div>
                </Link>
            </div>
              
        </div>



    </section>
  )
}

export default GenderCollectionSection
